import { render, staticRenderFns } from "./WorkerProfileReport.vue?vue&type=template&id=2ad48035"
import script from "./WorkerProfileReport.vue?vue&type=script&lang=js"
export * from "./WorkerProfileReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports